import { DraggableTypesEnum } from 'constants/builder/enums';
import { v4 as generateId } from 'uuid';

import type { QuestionnaireItems } from '../types';

export const addBlockVariationsHelper = (questions: QuestionnaireItems, blockId: string, data: any[]) => {
    const hasBlockVariations = questions.some(
        item => item.blockId === blockId && item.questionType === DraggableTypesEnum.Block
    );

    if (!hasBlockVariations) {
        const modifiedQuestions = questions.map(question => {
            if (question.blockId === blockId) {
                return {
                    ...question,
                    isShown: false
                };
            }

            return question;
        });

        return [
            ...modifiedQuestions,
            {
                questionType: DraggableTypesEnum.Block,
                description: data[0][0].description,
                title: data[0][0].title,
                type: data[0][0].type,
                variationsBlock: data,
                id: generateId(),
                isShown: true,
                blockId
            }
        ];
    }

    return questions.map(item => {
        if (item.blockId === blockId && item.questionType === DraggableTypesEnum.Block) {
            return {
                ...item,
                description: data[0][0].description,
                title: data[0][0].title,
                type: data[0][0].type,
                variationsBlock: data
            };
        }

        return item;
    });
};
